import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getUsers } from '../../services/usersService';
import {
  changeUserPasswordState,
  editingUserState,
  loadingUsersState,
  searchUsersState,
  updateUsersState,
  usersPageState,
  usersState,
} from '../../storage/users';
import { User } from '../../types/user';
import { PaginatedProvider } from './PaginatedProvider';

function UsersProvider() {
  const setPaginatedUsers = useSetRecoilState(usersState);
  const updateUsers = useRecoilValue(updateUsersState);
  const resetUpdateUsers = useResetRecoilState(updateUsersState);
  const resetEditingUser = useResetRecoilState(editingUserState);
  const resetChangePassword = useResetRecoilState(changeUserPasswordState);
  const setLoadingUsers = useSetRecoilState(loadingUsersState);

  return (
    <PaginatedProvider<User>
      searchState={searchUsersState}
      pageState={usersPageState}
      getPaginated={getUsers}
      setPaginated={setPaginatedUsers}
      onSearchChange={() => {}}
      onUpdateFinish={() => {
        resetUpdateUsers();
        resetEditingUser();
        resetChangePassword();
      }}
      setLoading={setLoadingUsers}
      update={updateUsers}
    />
  );
}

export default UsersProvider;
